import { Input, SelectPicker } from "rsuite";
import Responsive from "../../../../Components/Responsive";
import { classFlight } from "../../../../Constants/types";
import moment from "moment";
import styles from "./styles/departureFlightsStyles";
import { useEffect, useMemo, useState } from "react";
import { APi } from "../../../../Api";
import { calculateFlightDuration } from "../../../../Helpers/functions";
import Translation from "../../../../translation/translation";

const DepartureFlightForm = ({
  flight,
  handleChange,
  departureAirportData,
  arrivalAirportData,
  departureCity,
  setDepartureCity,
  arrivalCity,
  setArrivalCity,
  paysData,
  index,
  previousArrivalDate,
}) => {
  const handleFieldChange = (field, value) => {
    handleChange(index, field, value);
  };
  const [airportDepart, setAirportDepart] = useState("");
  const [airportReturn, setAirportReturn] = useState("");
  const durationRegex = /^(\d{0,2})(h)?( ?)?([0-5]?\d{0,1})?(m?)?$/;

  useEffect(() => {
    if (flight.departureAirportId) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Airport)
        .fetchById(flight.departureAirportId)
        .then((res) => {
          setAirportDepart(res.data);
        });
    }
  }, [flight.departureAirportId]);

  useEffect(() => {
    if (flight.arrivalAirportId) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Airport)
        .fetchById(flight.arrivalAirportId)
        .then((res) => {
          setAirportReturn(res.data);
        });
    }
  }, [flight.arrivalAirportId]);

  const paysOptions = useMemo(
    () => paysData?.map((c) => ({ label: c.nom, value: c.nom })) || [],
    [paysData]
  );

  const departureAirportOptions = useMemo(
    () =>
      departureAirportData?.map((c) => ({
        label: `${c.city} - ${c.name}`,
        value: c.id,
      })) || [],
    [departureAirportData]
  );

  const arrivalAirportOptions = useMemo(
    () =>
      arrivalAirportData?.map((c) => ({
        label: `${c.city} - ${c.name}`,
        value: c.id,
      })) || [],
    [arrivalAirportData]
  );
  // useEffect(() => {
  //   if (flight.departDate && flight.arrivalDate) {
  //     const duration = calculateFlightDuration(
  //       flight.departDate,
  //       flight.arrivalDate
  //     );
  //     handleFieldChange("flightDuration", duration);
  //   }
  // }, [flight.departDate, flight.arrivalDate]);

  const validateAndUpdateField = (fieldName, value) => {
    const parsedValue = parseFloat(value);
    if (parsedValue >= 0) {
      handleFieldChange(fieldName, parsedValue);
    }
  };

  return (
    <div>
      <div style={styles.container}>
        <Responsive className="p-5" m={6} l={3} xl={2}>
          <label>{Translation.name}: </label>
          <Input
            block
            value={flight.name || ""}
            onChange={(name) => handleFieldChange("name", name)}
          />
        </Responsive>

        <Responsive className="p-5" m={6} l={3} xl={2}>
          <label>{Translation.flightNumber}: </label>
          <Input
            block
            value={flight.flightNumber || ""}
            onChange={(flightNumber) =>
              handleFieldChange("flightNumber", flightNumber)
            }
          />
        </Responsive>
      </div>

      <div style={styles.container}>
        <Responsive className="p-5" m={6} l={3} xl={1.6}>
          <label>{Translation.countryDeparture}:</label>
          <SelectPicker
            data={paysOptions}
            block
            value={departureCity}
            onSelect={(pays) => setDepartureCity(pays)}
          />
        </Responsive>

        <Responsive className="p-5" m={6} l={3} xl={2}>
          <label>{Translation.airport}</label>
          <SelectPicker
            data={departureAirportOptions}
            block
            value={flight.departureAirportId}
            onSelect={(departureAirportId) =>
              handleFieldChange("departureAirportId", departureAirportId)
            }
          />
        </Responsive>
        <Responsive className="p-5" m={6} l={3} xl={2}>
          <label>{Translation.startingName}:</label>
          <Input block value={airportDepart.name || ""} disabled />
        </Responsive>
      </div>

      <div style={styles.container}>
        <Responsive className="p-5" m={6} l={3} xl={1.6}>
          <label>{Translation.countryArrival}:</label>
          <SelectPicker
            data={paysOptions}
            block
            value={arrivalCity}
            onSelect={(pays) => setArrivalCity(pays)}
          />
        </Responsive>

        <Responsive className="p-5" m={6} l={3} xl={2}>
          <label>{Translation.airport}</label>
          <SelectPicker
            data={arrivalAirportOptions}
            block
            value={flight.arrivalAirportId}
            onSelect={(arrivalAirportId) =>
              handleFieldChange("arrivalAirportId", arrivalAirportId)
            }
          />
        </Responsive>
        <Responsive className="p-5" m={6} l={3} xl={2}>
          <label>{Translation.arrivalName}:</label>
          <Input block value={airportReturn.name || ""} disabled />
        </Responsive>
      </div>

      <Responsive className="p-5" m={6} l={3} xl={1.5}>
        <label>{Translation.departureDate} :</label>
        <Input
          min={
            previousArrivalDate
              ? moment(previousArrivalDate).format("YYYY-MM-DDTHH:mm")
              : ""
          }
          type="datetime-local"
          value={moment(flight.departDate).format("YYYY-MM-DDTHH:mm") || ""}
          onChange={(departDate) => handleFieldChange("departDate", departDate)}
        />
      </Responsive>

      <Responsive className="p-5" m={6} l={3} xl={1.5}>
        <label>{Translation.arrivalDate}:</label>
        <Input
          min={moment(flight.departDate).format("YYYY-MM-DDTHH:mm")}
          type="datetime-local"
          value={moment(flight.arrivalDate).format("YYYY-MM-DDTHH:mm") || ""}
          onChange={(arrivalDate) =>
            handleFieldChange("arrivalDate", arrivalDate)
          }
        />
      </Responsive>

      <Responsive className="p-5" m={6} l={3} xl={1.3}>
        <label>{Translation.flightDuration}: </label>
        <Input
          block
          value={flight.flightDuration || ""}
          placeholder="1h 00m"
          onChange={(value) => {
            if (value === "" || durationRegex.test(value)) {
              handleFieldChange("flightDuration", value);
            }
          }}
          onBlur={() => {
            const finalRegex = /^\d{1,2}h [0-5]\d{1}m$/;
            if (!finalRegex.test(flight.flightDuration)) {
              handleFieldChange("flightDuration", "");
            }
          }}
        />
      </Responsive>

      <Responsive className="p-5" m={6} l={3} xl={1.6}>
        <label>{Translation.class}:</label>
        <SelectPicker
          data={classFlight}
          block
          noSearch
          value={flight.class}
          onChange={(className) => handleFieldChange("class", className)}
        />
      </Responsive>

      <Responsive className="p-5" m={3.5} l={2.2} xl={1.6}>
        <label>{Translation.handLuggage}:</label>
        <div style={styles.baggages}>
          <Input
            type="number"
            step="1"
            min="0"
            value={flight.nbrHandBaggages}
            onChange={(nbrHandBaggages) =>
              validateAndUpdateField("nbrHandBaggages", nbrHandBaggages)
            }
            style={styles.baggageInput}
          />

          <label style={styles.labelX}>x</label>

          <Input
            type="number"
            step="0.1"
            min="0"
            value={flight.handBaggages}
            onChange={(handBaggages) =>
              validateAndUpdateField("handBaggages", handBaggages)
            }
            style={{ flex: 1 }}
          />
          <label style={styles.labelKg}>Kg</label>
        </div>
      </Responsive>

      <Responsive className="p-5" m={3} l={2.2} xl={1.6}>
        <label>{Translation.luggage}:</label>
        <div style={styles.baggages}>
          <Input
            type="number"
            step="1"
            min="0"
            value={flight.nbrBaggages}
            onChange={(nbrBaggages) =>
              validateAndUpdateField("nbrBaggages", nbrBaggages)
            }
            style={styles.baggageInput}
          />

          <label style={styles.labelX}>x</label>

          <Input
            type="number"
            step="0.1"
            min="0"
            value={flight.baggages}
            onChange={(baggages) =>
              validateAndUpdateField("baggages", baggages)
            }
          />
          <label style={styles.labelKg}>Kg</label>
        </div>
      </Responsive>

      <Responsive className="p-5" m={8} l={6} xl={6}>
        <label>{Translation.description}: </label>
        <Input
          block
          value={flight.description || ""}
          onChange={(description) =>
            handleFieldChange("description", description)
          }
        />
      </Responsive>
    </div>
  );
};

export default DepartureFlightForm;
